<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            custom-class="dialog-role"
            width="420px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px">
            <el-form-item label="角色名" prop="nameZh">
                <el-input type="text" v-model="dataForm.nameZh" style="width: 90%;"></el-input>
            </el-form-item>
            <el-form-item label="角色编码" prop="name">
                <el-input type="text" v-model="dataForm.name" style="width: 90%;">
                    <template slot="prepend">ROLE_</template>
                </el-input>
            </el-form-item>
            <el-tree
                    :data="menuData"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    @check="decideNode"
                    :default-expand-all="true"
                    :default-checked-keys="dataForm.dck"
                    :props="defaultProps">
            </el-tree>
            <div v-if="dataForm.id===1" style="padding-top: 20px;">
                <span style="color: red;">*</span>
                <span style="font-size: 12px;letter-spacing: 1px;">
                    超级管理员角色默认所有权限，若修改请联系管理员！
                </span>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="dataFormSubmit()" :disabled="dataForm.id===1">保存</el-button>
            </span>
    </el-dialog>
</template>

<script>
    import {SysRole} from "../../api/sysRole";
    import {SysMenu} from "../../api/sysMenu";
    import $ from 'jquery'

    export default {
        name: "sys-role-add-or-update",
        data() {
            let validateName = (rule, value, callback) => {
                let params = {'name': 'ROLE_' + value};
                if (value !== this.dataForm.tempName) {
                    SysRole.getRoleByName(params).then(res => {
                        if (res.validate) {
                            callback(new Error('角色编码不能重复，请重新输入！'))
                        } else {
                            callback()
                        }
                    })
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                disBtn: true,
                pwdFlag: false,
                dataForm: {
                    id: 0,
                    nameZh: '',
                    name: '',
                    dck: [2],
                    tempName: '',
                },
                MenuList: [],
                dataRule: {
                    nameZh: [
                        {required: true, message: '角色名不能为空', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '角色编码不能为空', trigger: 'blur'},
                        {validator: validateName, trigger: 'blur'}
                    ]
                },
                menuData: [],
                menus: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                powerList: [
                    {id: '-add', label: '新增'},
                    {id: '-edit', label: '编辑'},
                    {id: '-delete', label: '删除'}
                ]
            }
        },
        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields();
                        this.dataForm.dck = [2];
                    });
                }
            }
        },
        methods: {
            decideNode(data, obj) {

            },
            getMenuList() {
                SysMenu.getMenuList().then(res => {
                    this.menus = res.menuList;
                    this.menuData = this.formatList(res.menuList);
                    //console.log(this.menuData)
                }).catch(res => {
                    console.log(res)
                })
            },
            formatList(list) {
                let menus = [];
                let menuList = list;
                for (let i = 0; i < menuList.length; i++) {
                    if (menuList[i].parentId === 1 && menuList[i].id !== 8) {
                        let obj = {
                            id: menuList[i].id,
                            index: menuList[i].index,
                            label: menuList[i].name,
                            children: []
                        };
                        if (menuList[i].id === 2) {
                            obj.disabled = true;
                        }
                        menus.push(obj);
                    }
                }
                for (let i = 0; i < menus.length; i++) {
                    for (let j = 0; j < menuList.length; j++) {
                        if (menuList[j].parentId === menus[i].id) {
                            menus[i].children.push({
                                id: menuList[j].id,
                                index: menuList[j].index,
                                label: menuList[j].name,
                                children: []
                            })
                        }
                    }
                    for (let j = 0; j < menus[i].children.length; j++) {
                        for (let k = 0; k < menuList.length; k++) {
                            if (menuList[k].parentId === menus[i].children[j].id) {
                                menus[i].children[j].children.push({
                                    id: menuList[k].id,
                                    index: menuList[k].index,
                                    label: menuList[k].name,
                                    children: []
                                });
                            }
                        }
                        if (menus[i].children[j].children.length === 0) {
                            if (menus[i].children[j].id === 10) {
                                menus[i].children[j].children.push({
                                    id: menus[i].children[j].index + '-delete',
                                    label: this.powerList[2].label,
                                    children: []
                                })
                            } else if (menus[i].children[j].id !== 19 && menus[i].children[j].id !== 20) {
                                for (let a = 0; a < this.powerList.length; a++) {
                                    menus[i].children[j].children.push({
                                        id: menus[i].children[j].index + this.powerList[a].id,
                                        label: this.powerList[a].label,
                                        children: []
                                    })
                                }
                            }
                        } else {
                            for (let k = 0; k < menus[i].children[j].children.length; k++) {
                                if (menus[i].children[j].children[k].children.length === 0) {
                                    for (let a = 0; a < this.powerList.length; a++) {
                                        menus[i].children[j].children[k].children.push({
                                            id: menus[i].children[j].children[k].index + this.powerList[a].id,
                                            label: this.powerList[a].label,
                                            children: []
                                        })
                                    }
                                }
                            }
                        }
                    }
                    if (menus[i].children.length === 0) {
                        for (let a = 0; a < this.powerList.length; a++) {
                            if (menus[i].id !== 2) {
                                menus[i].children.push({
                                    id: menus[i].index + this.powerList[a].id,
                                    label: this.powerList[a].label,
                                    children: []
                                })
                            }
                        }
                    }
                }
                return menus;
            },
            /**
             * 弹窗初始化
             */
            init(id) {
                this.visible = true;
                this.disBtn = true;
                this.dataForm.id = id;
                $(".dialog-role").parent('div').css('overflow', 'hidden');
                this.getMenuList();
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                });
                if (this.dataForm.id) { // 查询
                    SysRole.getRoleInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            let temp = [2];
                            let mrList = res.objectMap.mrList;
                            let name = res.objectMap.sysRole.name;
                            this.dataForm.nameZh = res.objectMap.sysRole.nameZh;
                            this.dataForm.name = name.substring(5, name.length);
                            this.dataForm.tempName = name.substring(5, name.length);
                            mrList.forEach((item, index) => {
                                if (mrList[0].name === '所有') {
                                    temp.push(item.id);
                                } else {
                                    if (item.addPower !== '') {
                                        temp.push(item.addPower);
                                    }
                                    if (item.editPower !== '') {
                                        temp.push(item.editPower);
                                    }
                                    if (item.deletePower !== '') {
                                        temp.push(item.deletePower);
                                    }
                                }
                            });
                            this.dataForm.dck = temp;
                            //console.log(temp)
                        }
                    });
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let mids = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
                let datas = {
                    'id': this.dataForm.id,
                    'name': 'ROLE_' + this.dataForm.name,
                    'nameZh': this.dataForm.nameZh,
                    'mids': this.getMids(mids)
                };
                // console.log(this.getMids(mids));
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        SysRole.addOrUpdateRole(datas, type).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            },
            getMids(mids) {
                let menus = this.menus;
                let midArray = [];
                for (let i = 0; i < mids.length; i++) {
                    for (let j = 0; j < menus.length; j++) {
                        if (typeof mids[i] === 'number' && !isNaN(mids[i]) && mids[i] === menus[j].id) {
                            midArray.push({
                                mid: mids[i],
                                index: menus[j].index
                            });
                        }
                    }
                }
                for (let i = 0; i < midArray.length; i++) {
                    for (let j = 0; j < mids.length; j++) {
                        if (mids[j].toString().indexOf(midArray[i].index) !== -1) {
                            if (mids[j].toString().indexOf('-add') !== -1) {
                                midArray[i].addPower = mids[j];
                            }
                            if (mids[j].toString().indexOf('-edit') !== -1) {
                                midArray[i].editPower = mids[j];
                            }
                            if (mids[j].toString().indexOf('-delete') !== -1) {
                                midArray[i].deletePower = mids[j];
                            }
                        }
                    }
                    if (!midArray[i].addPower) {
                        midArray[i].addPower = 'empty';
                    }
                    if (!midArray[i].editPower) {
                        midArray[i].editPower = 'empty';
                    }
                    if (!midArray[i].deletePower) {
                        midArray[i].deletePower = 'empty';
                    }
                }
                for (let i = 0; i < midArray.length; i++) {
                    delete midArray[i].index
                }
                return midArray;
            }
        }
    }
</script>

<style>

    .dialog-role {
        width: auto;
        margin-top: 0 !important;
        height: 100%;
        overflow: auto;
    }

    .dialog-role .el-dialog__footer {
        width: 100%;
        text-align: center;
    }

    .dialog-role .el-button + .el-button {
        margin-left: 20px !important;
    }

</style>
